import { createApp } from 'vue';
import { VueQueryPlugin } from '@tanstack/vue-query';
import App from './App.vue';
import router from './router';
import { queryClient } from '@/lib/query-client';
import { initializeAuth } from '@/lib/auth-service';
// Side-effect: registers the ECharts renderer/charts/components once, process-wide.
import '@/lib/echarts';
import './assets/main.css';

document.documentElement.classList.add('dark');

// Register the Supabase onAuthStateChange listener + boot sync before mount
// (replaces the old Pinia store's lazy auto-init on first useAuthStore()).
initializeAuth();

const app = createApp(App);

app.use(VueQueryPlugin, { queryClient });
app.use(router);

app.mount('#app');
